import React from 'react';
import { useTranslation } from 'react-i18next';
import UiIcon from '../icons/UiIcon';

/**
 * The taskbar of parked forms, bottom-right. Each chip is a form the user
 * minimised with its draft still in memory — clicking it brings the window
 * back exactly as it was left.
 *
 * It renders nothing when nothing is parked, so the app looks untouched until
 * the user actually parks something. The chips live ABOVE the router in the
 * tree, which is what lets a half-typed "Add Lead" survive a trip to another
 * page and still be waiting when the user comes back.
 */
export default function FormWindowDock({ windows, onRestore, onClose }) {
  const { t } = useTranslation();

  if (windows.length === 0) return null;

  return (
    <div className="fw-dock" role="group" aria-label={t('formWindow.dockLabel')}>
      {windows.map((win) => (
        <div className="fw-chip" key={win.id}>
          <button
            type="button"
            className="fw-chip-open"
            onClick={() => onRestore(win.id)}
            title={t('formWindow.restoreDraft', { title: win.title })}
          >
            <UiIcon name="chevronUp" className="h-3.5 w-3.5 shrink-0" />
            <span className="fw-chip-label">{win.title}</span>
          </button>
          <button
            type="button"
            className="fw-chip-close"
            aria-label={t('formWindow.discardDraft', { title: win.title })}
            title={t('formWindow.discardDraft', { title: win.title })}
            onClick={() => onClose(win.id)}
          >
            <UiIcon name="close" className="h-3 w-3" />
          </button>
        </div>
      ))}
    </div>
  );
}
